import React, { useState } from 'react';
import { useI18n } from '../../context/I18nContext';
import Button from '../ui/Button';
import { trackUmamiEvent } from '../../utils/umami';

/**
 * Shown when signup happens with the burger shell: guided demo is deferred to desktop rail.
 * User already has their empty personal workspace — this is only an informational warning.
 */
const DemoDeferredMobile: React.FC = () => {
  const { t } = useI18n();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      className="md:hidden fixed z-[2100] left-0 right-0 bottom-3 px-3 pointer-events-none"
      role="status"
      aria-label={t('demoTour.deferredTitle')}
    >
      <div className="pointer-events-auto mx-auto max-w-md rounded-2xl border border-primary-200 bg-white shadow-xl shadow-slate-900/10 ring-1 ring-primary-500/20 p-4">
        <h2 className="text-base font-semibold text-slate-900">{t('demoTour.deferredTitle')}</h2>
        <p className="mt-1.5 text-sm text-slate-600 leading-snug">{t('demoTour.deferredBody')}</p>
        <Button
          type="button"
          variant="primary"
          size="md"
          className="w-full mt-3"
          onClick={() => {
            trackUmamiEvent('demo_deferred_dismiss');
            setDismissed(true);
          }}
        >
          {t('demoTour.deferredDismiss')}
        </Button>
      </div>
    </div>
  );
};

export default DemoDeferredMobile;
